import { render, staticRenderFns } from "./StepMissingMortgage.vue?vue&type=template&id=0e6876d2&scoped=true"
import script from "./StepMissingMortgage.vue?vue&type=script&lang=js"
export * from "./StepMissingMortgage.vue?vue&type=script&lang=js"
import style0 from "./StepMissingMortgage.vue?vue&type=style&index=0&id=0e6876d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6876d2",
  null
  
)

export default component.exports